import * as React from "react";

export default class LoadingSpinner extends React.PureComponent {
  render() {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }
}
